import React, { memo, useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { FormInput, FormHelpers } from '../components';
import { APPT_TYPES } from '../../constants/eventTypes';
import { THEME } from '../../constants/styles';

const publicTypesRef = React.createRef();
const adminTypesRef = React.createRef();
const windowsRef = React.createRef();

function validateEventTypesList(value) {
  let isValid = true;
  value.split(',').map((item) => {
    const trimmed = item.trim();
    if (trimmed && APPT_TYPES.indexOf(trimmed) === -1) {
      isValid = false;
    }
  });
  return isValid;
}

function validateEventTypesWindowsList(value) {
  let isValid = true;
  value.split(',').map((item) => {
    const [type, window] = item.split(':').map((part) => part.trim());
    if (type) {
      if (APPT_TYPES.indexOf(type) === -1) {
        isValid = false;
      }
      if (isNaN(parseInt(window))) {
        isValid = false;
      }
    }
  });
  return isValid;
}

const EventTypesForm = memo((props) => {
  const employer = props.employer || {};
  const eventTypesConfiguration = employer.eventTypesConfiguration || {};
  const [publicTypes, setPublicTypes] = useState(
    eventTypesConfiguration.eventTypesPublic
      ? eventTypesConfiguration.eventTypesPublic.join(', ')
      : ''
  );
  const [adminTypes, setAdminTypes] = useState(
    eventTypesConfiguration.eventTypesAdmin
      ? eventTypesConfiguration.eventTypesAdmin.join(', ')
      : ''
  );
  const [windows, setWindows] = useState(
    eventTypesConfiguration.eventTypeSchedulingWindows
      ? Object.entries(eventTypesConfiguration.eventTypeSchedulingWindows)
          .map(([type, window]) => `${type}: ${window}`)
          .join(', ')
      : ''
  );

  useEffect(() => {
    const isValid = FormHelpers.validateFields([
      publicTypesRef.current,
      adminTypesRef.current,
      windowsRef.current,
    ]);
    const eventTypesPublic = publicTypes
      ? publicTypes
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item)
      : [];
    const eventTypesAdmin = adminTypes
      ? adminTypes
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item)
      : [];
    const eventTypeSchedulingWindows = windows
      ? windows.split(',').reduce((acc, item) => {
          const [type, window] = item.split(':').map((part) => part.trim());
          acc[type] = parseInt(window);
          return acc;
        }, {})
      : {};
    const eventTypesConfiguration = {
      eventTypesPublic,
      eventTypesAdmin,
      eventTypeSchedulingWindows,
    };
    props.onDataChange({ ...employer, eventTypesConfiguration }, isValid);
  }, [publicTypes, adminTypes, windows]);

  return (
    <View style={{ marginBottom: 20 }}>
      <Text style={[THEME.textSemibold, { fontSize: 14, marginBottom: 10 }]}>
        Available Event Types:
      </Text>
      <Text style={[THEME.textRegular, { fontSize: 16, marginBottom: 20 }]}>
        {APPT_TYPES.join(', ')}
      </Text>
      <FormInput
        ref={publicTypesRef}
        value={publicTypes}
        label={'Public Event Types (In Order)'}
        tipText="Airforce Deployment, Immunization Appointment, DRHA Appointment"
        invalidText="Airforce Deployment, Immunization Appointment, DRHA Appointment"
        required={true}
        onChangeText={setPublicTypes}
        controlled={true}
        autoCorrect={false}
        selectTextOnFocus={false}
        validateFunc={validateEventTypesList}
      />
      <FormInput
        ref={adminTypesRef}
        value={adminTypes}
        label={'Admin Event Types (In Order)'}
        tipText="Airforce Deployment, Immunization Appointment, DRHA Appointment"
        invalidText="Airforce Deployment, Immunization Appointment, DRHA Appointment"
        required={true}
        onChangeText={setAdminTypes}
        controlled={true}
        autoCorrect={false}
        selectTextOnFocus={false}
        validateFunc={validateEventTypesList}
      />
      <FormInput
        ref={windowsRef}
        value={windows}
        label={'Scheduling Windows (For Public Types)'}
        invalidText="Airforce Deployment: 45, Immunization Appointment: 30, DRHA Appointment: 60"
        tipText="Airforce Deployment: 45, Immunization Appointment: 30, DRHA Appointment: 60"
        required={true}
        onChangeText={setWindows}
        controlled={true}
        autoCorrect={false}
        selectTextOnFocus={false}
        validateFunc={validateEventTypesWindowsList}
      />
    </View>
  );
});

export default EventTypesForm;
